<template>
  <section class="asc-terms-and-conditions-wrapper">
    <div class="asc-terms-and-conditions--heading">
      <asc-header
        :color="headerColor"
        size="h2"
        uppercase
        value="Terms and Conditions"
      />
    </div>
    <div ref="termsBody" class="asc-terms-and-conditions--body">
      <asc-terms-and-conditions />
    </div>
    <div class="asc-terms-and-conditions--footer">
      <template v-if="!userAccepted">
        <asc-checkbox
          v-model="acceptTerms"
          class="asc-terms-and-conditions--footer__checkbox"
          :disabled="!readAll"
          label="I have read and accept the terms and conditions."
        />
        <asc-accent-button
          button-text="Accept"
          custom-class="asc-terms-and-conditions--footer__button"
          :disabled="disableSubmit"
          :loading="loading"
          :on-click="submitTermsAndConditions"
        />
      </template>
      <template v-else>
        <span class="asc-terms-and-conditions--footer__text">
          Accepted on {{ lastAccepted }}
        </span>
      </template>
    </div>
  </section>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscCheckbox from '@/components/atoms/AscCheckbox'
import AscHeader from '@/components/atoms/AscHeader'
import AscTermsAndConditions from '@/components/atoms/AscTermsAndConditions'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscTermsAndConditionsWrapper',

  components: {
    AscAccentButton,
    AscCheckbox,
    AscHeader,
    AscTermsAndConditions,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    lastAccepted: {
      type: String,
      default: '',
    },
    userAccepted: {
      type: Boolean,
      default: false,
    },
    showAcceptControls: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      acceptTerms: false,
      disableSubmit: true,
      readAll: false,
      hasScrollbar: false,
      termsBody: null,
    }
  },

  computed: {
    headerColor() {
      return variables.gray900
    },
  },

  watch: {
    acceptTerms() {
      this.disableSubmit = !this.acceptTerms
    },
  },

  mounted() {
    if (this.$refs && this.$refs.termsBody)
      this.termsBody = this.$refs.termsBody
    this.getTermsWidth()
    this.scrollEvent()
    window.addEventListener('resize', this.handleResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    getTermsWidth() {
      this.hasScrollbar =
        this.termsBody.scrollHeight > this.termsBody.clientHeight
    },
    scrollEvent() {
      if (this.hasScrollbar) {
        this.termsBody.onscroll = () => {
          // If user has scrolled to the bottom of the terms info this.readAll will become true
          const bottomOfTerms =
            this.termsBody.scrollHeight - this.termsBody.scrollTop ===
            this.termsBody.clientHeight

          if (bottomOfTerms) this.readAll = true
        }
      } else {
        this.readAll = true
      }
    },
    submitTermsAndConditions() {
      this.$emit('submitTAndC')
    },
    handleResize() {
      this.getTermsWidth()
      if (!this.hasScrollbar) this.readAll = true
    },
  },
}
</script>

<style lang="scss">
.asc-terms-and-conditions {
  &--body {
    border: 1px solid $gray-400;
    max-height: 402px;
    margin-bottom: 27px;
    padding: 12px;
    overflow-y: auto;
    width: 100%;

    &__text:last-child {
      margin-bottom: 0;
    }
  }

  &--footer {
    align-items: center;
    display: flex;
    flex-flow: column nowrap;

    &__button {
      width: 160px;
    }

    &__checkbox {
      margin-right: 0 !important;
      margin-bottom: 22px;
    }
  }

  &--heading {
    margin-bottom: 12px;
  }

  &-wrapper {
    align-items: center;
    background-color: $primary-white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    justify-content: center;
    padding: 33px;
    width: 100%;
  }
}
</style>
